import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import { useAcombaBridgeStore } from '../../stores/acombaBridgeStore';
import { useIsAcomba } from '../../hooks/useIsAcomba';
import { TranslationKey } from '../../i18n/translationKeys';
import { BridgeWizard } from './BridgeWizard';
import { PageTitle } from '../../ui/PageTitle/PageTitle';
import { ConnectedView } from './ConnectedView';
import { SessionReasonBanner } from './SessionReasonBanner';
import { SkeletonBar } from '../../ui/Skeleton/SkeletonBar';

export const AcombaPage: React.FC = () => {
    const { t } = useTranslation();
    const isAcomba = useIsAcomba();
    const bridgeStatus = useAcombaBridgeStore((s) => s.bridgeStatus);
    const sessionStatus = useAcombaBridgeStore((s) => s.sessionStatus);

    if (!isAcomba) return <Navigate to="/not-found" replace />;

    const skeleton = (
        <div className="flex flex-col gap-xl">
            <div className="flex flex-col gap-l">
                {[0, 1, 2, 3].map((i) => (
                    <div key={i} className="flex flex-col gap-s">
                        <SkeletonBar className="h-4 w-28" />
                        <SkeletonBar className="h-5 w-40" />
                    </div>
                ))}
            </div>
        </div>
    );

    const body = (() => {
        if (bridgeStatus === 'unreachable') return <BridgeWizard />;
        if (sessionStatus === 'idle') return skeleton;
        if (sessionStatus === 'connected') return <ConnectedView />;
        return <SessionReasonBanner />;
    })();

    return (
        <div className="max-w-4xl mx-auto flex flex-col gap-xl">
            <PageTitle>{t(TranslationKey.AcombaBridge.PanelTitle)}</PageTitle>
            {body}
        </div>
    );
};
